import { render, staticRenderFns } from "./TheChat.vue?vue&type=template&id=38060c2c"
import script from "./TheChat.vue?vue&type=script&lang=js"
export * from "./TheChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports